import { Award, AwardCount } from "@hubcapp/types";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import AwardsList from "./AwardsList";
import React from "react";

const useStyles = makeStyles(theme => ({
  cardContent: {
    padding: theme.spacing(3, 3, 3, 2),
  },
  title: {
    padding: theme.spacing(0),
    marginBottom: theme.spacing(2),
  },
  subTitle: {
    fontWeight: 300,
    fontSize: "15px",
    lineHeight: "150%",
  },
}));

const MyAwards: React.FC<{ awards?: AwardCount[]; loading?: boolean }> = ({
  awards,
  loading,
}) => {
  const classes = useStyles();

  const sortedAllAwards = Object.values(Award)
    .map(award => {
      const existing = awards ? awards.find(a => a.award === award) : undefined;
      if (existing) {
        return existing;
      }

      return {
        award: award,
        count: 0,
      };
    })
    .sort((a, b) => b.count - a.count);

  const topAwards = sortedAllAwards.slice(0, 4).filter(a => a.count > 0);
  const remainingAwards = sortedAllAwards.filter(
    a => !topAwards.some(topAward => topAward.award === a.award),
  );

  return (
    <Card data-test="my-awards">
      <CardContent className={classes.cardContent}>
        <Box marginBottom={2}>
          <Typography
            variant="h2"
            color="textSecondary"
            className={classes.title}
          >
            Your Awards
          </Typography>

          {topAwards.length != 0 || loading ? (
            <Typography
              variant="h3"
              color="textPrimary"
              className={classes.subTitle}
            >
              These awards are supported by your learners. The 4 highest
              supported awards will appear on your public business profile.
            </Typography>
          ) : (
            <Typography variant="h3" color="error" className={classes.subTitle}>
              You currently have no supporters for your awards. These awards
              will remain hidden on your public business profile until you gain
              some backing from your learners. Encourage your learners to
              support you.
            </Typography>
          )}
        </Box>

        {loading ? (
          <Grid>
            {[...Array(3)].map((_, idx) => (
              <Box key={idx} mb={2}>
                <Skeleton key={idx} width="100%" height="35px" />
              </Box>
            ))}
          </Grid>
        ) : (
          <AwardsList topAwards={topAwards} remainingAwards={remainingAwards} />
        )}
      </CardContent>
    </Card>
  );
};
export default MyAwards;
